import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 控制大背景的边框北京线是否显示
    isShowbg: true,
    earlyMsg: {},
    connectInfo: false,
    msgShareToTaskInfo: false,
    //控制预警弹框是否显示
    isShowWarningBox: true,
  },
  mutations: {
    setIsShowbg(state, val) {
      state.isShowbg = val;
    },
    setEarlyMsg(state, val) {
      state.earlyMsg = val;
    },
    setConnect(state, val) {
      state.connectInfo = val;
    },
    setMsgToTask(state, val) {
      state.msgShareToTaskInfo = val;
      console.log(state.msgShareToTaskInfo)
    },
  },
  actions: {
    submitIsShowbg({ commit }, val) {
      commit('setIsShowbg', val)
    },
    submittEarlyMsg({ commit }, val) {
      commit('setEarlyMsg', val)
    },
    submitConnect({ commit }, val) {
      commit('setConnect', val)
    },
    submitMsgTask({ commit }, val) {
      commit('setMsgToTask', val)
    },
  },
  getters: {
    isShowbgImg(state) {
      return state.isShowbg;
    },
    getEarlymsg(state) {
      return state.earlyMsg;
    },
    getConnect(state) {
      return state.connectInfo;
    },
    getMsgTask(state) {
      return state.msgShareToTaskInfo;
    },
    isShowWarningBox(state) {
      return state.isShowWarningBox
    }
  }
})
